import { useContext } from 'react';
import { GeneralProductionChartsDataContext } from '../contexts/GeneralProductionChartsDataContext';

export const useGeneralProductionChartsDataContext = () => {
    return useContext(GeneralProductionChartsDataContext);
};
